/* BeautyOnTApp merchant-listing remediation: remove undated sale markup only. */
(() => {
  'use strict';

  const selector = 'script.webrex_seo_schema[type="application/ld+json"]';

  function hasValidFrom(offer, specification) {
    const value = offer && offer.validFrom ? offer.validFrom : specification && specification.validFrom;
    return typeof value === 'string' && value.trim().length > 0;
  }

  function isUndatedStrikethrough(offer, specification) {
    return specification
      && typeof specification === 'object'
      && String(specification.priceType || '').endsWith('StrikethroughPrice')
      && !hasValidFrom(offer, specification);
  }

  function sanitise(node) {
    if (Array.isArray(node)) {
      let changed = false;
      node.forEach((item) => {
        if (sanitise(item)) changed = true;
      });
      return changed;
    }
    if (!node || typeof node !== 'object') return false;

    let changed = false;
    const type = node['@type'];
    const isOffer = type === 'Offer' || (Array.isArray(type) && type.includes('Offer'));

    if (isOffer && node.priceSpecification) {
      const original = Array.isArray(node.priceSpecification)
        ? node.priceSpecification
        : [node.priceSpecification];
      const retained = original.filter((specification) => !isUndatedStrikethrough(node, specification));

      if (retained.length !== original.length) {
        changed = true;
        if (retained.length === 0) {
          delete node.priceSpecification;
        } else {
          node.priceSpecification = Array.isArray(node.priceSpecification) ? retained : retained[0];
        }
      }
    }

    Object.values(node).forEach((value) => {
      if (sanitise(value)) changed = true;
    });
    return changed;
  }

  function processScript(script) {
    try {
      const data = JSON.parse(script.textContent || '');
      if (sanitise(data)) script.textContent = JSON.stringify(data);
    } catch (_) {
      // Leave malformed or non-JSON-LD payloads untouched.
    }
  }

  function scan() {
    document.querySelectorAll(selector).forEach(processScript);
  }

  function start() {
    scan();
    [250, 1000, 3000, 6000].forEach((delay) => window.setTimeout(scan, delay));
    new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.target && record.target.matches && record.target.matches(selector)) {
          processScript(record.target);
        }
        record.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(selector)) processScript(node);
          if (node.querySelectorAll) node.querySelectorAll(selector).forEach(processScript);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();